import { CommentatorReaction } from "@/components/commentator-reaction"
import { RevealBlock } from "@/components/reveal-block"
import { SegmentHeader } from "@/components/segment-header"
import { SlamBlock } from "@/components/slam-block"
import { SmallPortrait } from "@/components/small-portrait"

import { CommentaryPanel } from "./commentary-panel"
import { COMMENTATORS } from "./commentators"
import { HomepageCta } from "./homepage-cta"

const SIGNOFF_LINES = [
  {
    commentatorKey: "grak_ironjaw",
    name: "Grak Ironjaw",
    mood: "neutral",
    line: "That's the broadcast. You in or not?",
    side: "left" as const,
  },
  {
    commentatorKey: "vaeltharion_the_unimpressed",
    name: "Vaeltharion",
    mood: "smug",
    line: "If someone sent you here, they either like you or want to watch you suffer. Both are valid.",
    side: "right" as const,
  },
  {
    commentatorKey: "skrix_dataclack",
    name: "Skrix Dataclack",
    mood: "excited",
    line: "Sign up, sign up! More coaches means more matches means more data, yes-yes!",
    side: "left" as const,
  },
]

const TIMING = {
  portraits: 0.1, // commentator portrait strip
  commentaryStart: 0.2, // first sign-off line
  commentaryStagger: 0.15, // between sign-off lines
  ctaPanel: 0.5, // CTA slam-in
} as const

interface SignoffSectionProps {
  portraitUrls: Record<string, string>
}

export function SignoffSection({ portraitUrls }: SignoffSectionProps) {
  return (
    <>
      {/* ── Header + portraits ── */}
      <div className="mx-auto max-w-5xl px-4">
        <RevealBlock>
          <SegmentHeader label="End of Broadcast" />
        </RevealBlock>

        <RevealBlock delay={TIMING.portraits}>
          <p
            className="font-display mt-8 mb-3 text-center text-[10px] tracking-[0.3em] uppercase"
            style={{ color: "oklch(0.45 0.02 55)" }}
          >
            Your Broadcast Desk
          </p>
          <div className="flex items-center justify-center gap-5">
            {COMMENTATORS.map((c) => (
              <SmallPortrait
                key={c.key}
                commentatorKey={c.key}
                name={c.name}
                portraitUrl={portraitUrls[`${c.key}_neutral`] ?? null}
              />
            ))}
          </div>
        </RevealBlock>
      </div>

      {/* ── Sign-off commentary ── */}
      <CommentaryPanel>
        {SIGNOFF_LINES.map((entry, i) => (
          <SlamBlock
            key={entry.commentatorKey}
            from={entry.side}
            delay={TIMING.commentaryStart + i * TIMING.commentaryStagger}
          >
            <CommentatorReaction
              commentatorKey={entry.commentatorKey}
              name={entry.name}
              mood={entry.mood}
              line={entry.line}
              portraitUrl={
                portraitUrls[`${entry.commentatorKey}_${entry.mood}`] ?? null
              }
              side={entry.side}
            />
          </SlamBlock>
        ))}
      </CommentaryPanel>

      {/* ── CTA ── */}
      <SlamBlock from="bottom" delay={TIMING.ctaPanel}>
        <HomepageCta />
      </SlamBlock>
    </>
  )
}
